<script>
import { orderReportMethods, toasterMethods, userMethods } from '@state/helpers'
import constant from '@constants/constant'
import common from '@state/modules/common'

export default {
  props: {
    customerId: {
      type: Number || String,
      default: '',
    },
    customerUserId: {
      type: Number || String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    customerUserCodeArray: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      birthdate: '2019-01-01',
      getCras: [],
      isDisabled: false,
      titleHeader: '',
      startdate: '',
      trimergeJsonData: '',
      pageNumber: 1,
      pageSize: 10000,
      title: constant.ccrReportTitle,
      customer: '',
      customerUser: '',
      referenceNumber: '',
      firstName: '',
      middleName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      suffix: '',
      ssn: '',
      streetAddress: '',
      cityName: '',

      ssnValue: 0,
      signedfile: null,
      PreviousStreetAddress: '',
      propertyStreetAddress: '',
      propertyCityName: '',
      propertyState: '',
      propertyZip: '',
      stateCode: '',
      previousState: '',
      previousStateCode: '',
      maritalStatusCode: '',
      suffixCode: '',
      propertyStateCode: '',
      previousZip: '',
      PreviousCityName: '',
      xp: [],
      tu: [],
      eq: ['eqr', 'eqs'],
      months: constant.months,
      userInfo: {},
      state: '',
      customerCode: '',
      zip: '',
      lengthofStayInMonths: '',
      maxbirtdate: '',
      xpReportSelected: false,
      xpScoreSelected: false,
      xpFraudSelected: false,
      tuReportSelected: false,
      tuScoreSelected: false,
      tuFraudSelected: false,
      eqReportSelected: true,
      eqScoreSelected: true,
      lengthofStayInYears: '',
      previousLengthofStayInYears: '',
      loanTypeDescription: '',
      numberofDependencies: '',

      loanType: '',
      loanTypeCode: '',
      showSpinner: false,
      coborrower: false,
      coborrowerData: '',
      previousAddress: false,
      previousAddressData: {},
      subjectProperty: false,
      alertMessage: '',
      maritalStatus: '',
      showBureauError: false,
      isDateValid: true,
      propertyAddressSelected: false,
      customers: [],
      reportType: 2,
      cras: [
        {
          title: 'XP',
          Report: 'xpr',
          Score: 'xps',
          Fraud: 'xpf',
        },
        {
          title: 'TU',
          Report: 'tur',
          Score: 'tus',
          Fraud: 'tuf',
        },
        {
          title: 'EQ',
          Report: 'eqr',
          Score: 'eqs',
          Fraud: 'eqf',
        },
      ],
      craTableHeaders: [
        { key: 'title', label: '', sortable: false },
        { key: 'Report', label: 'Report', sortable: false },
        { key: 'Score', label: 'Score', sortable: false },
        { key: 'Fraud', label: 'Fraud', sortable: false },
      ],
      customerUsers: [],
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'Services',
          to: { path: '/home' },
        },
        {
          text: 'Business Credit',
          to: { path: '/home' },
        },
        {
          text: 'Order Report',
          active: true,
        },
      ],
      typeOption: [
        { text: 'Financial', value: 1 },
        { text: 'Non Financial', value: 2 },
      ],
    }
  },
  computed: {
    placeholders() {
      return {
        startdate: 'MM/DD/YYYY',
        referenceNumber: 'Reference Number',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        lengthofStayInYears: 'Length of Stay',
        phoneNumber: '(xxx) xxx-xxxx',
        email: 'Email ID',
        ssn: 'xxx-xx-xxxx',
        streetAddress: 'Street Address',
        PreviousStreetAddress: 'Street Address',
        cityName: 'City Name',
        zip: 'xxxxx-xxxx',
        taxID: 'Tax ID',
        numberofDependencies: 'Number of Dependents',
        lengthofStayInMonths: 'Select',
      }
    },

    states() {
      return this.$_allStates
    },

    suffixes() {
      return this.$_suffixes
    },

    loanTypes() {
      return this.$_CCRLoanTypes
    },

    maritalStatusList() {
      return this.$_maritalStatuses
    },
  },
  mounted() {
    this.getCustomer()
    this.getMaxDateLimit()
    this.userInfo = this.$store.state.auth.currentUser.userInfo
  },
  methods: {
    ...userMethods,
    ...orderReportMethods,
    ...toasterMethods,
    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
        if (method) {
          method()
        }
      })
    },
    toggleEventParent: function() {
      this.previousAddress = !this.previousAddress
      if (this.previousAddress === true) {
        this.PreviousStreetAddress = this.PreviousStreetAddress
        this.PreviousCityName = this.PreviousCityName
        this.previousState = this.previousState
        this.previousZip = this.previousZip
      } else {
        this.PreviousStreetAddress = ''
        this.PreviousCityName = ''
        this.previousState = ''
        this.previousZip = ''
      }
    },
    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxbirtdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },

    orderConsumerCreditReport() {
      this.getStateCode()
      this.getPreviousStateCode()
      this.getPropertyStateCode()
      this.getLoanTypeCode()
      this.getMaritalStatusCode()
      this.getOptionSuffixCode()
      if (this.productId === '22') {
        this.OrderReport()
        // Call javascript function to place order for CCR via MCL
      } else {
        this.searchOrderCCRReports()
      }
    },

    getStateCode() {
      if (this.state !== '') {
        this.stateCode = this.states.find(
          (x) => x.value === Number(this.state)
        ).stateCode
      }
    },
    getPreviousStateCode() {
      if (this.previousState !== '') {
        this.previousStateCode = this.states.find(
          (x) => x.value === Number(this.previousState)
        ).stateCode
      }
    },
    getPropertyStateCode() {
      if (this.propertyState !== '') {
        this.propertyStateCode = this.states.find(
          (x) => x.value === Number(this.propertyState)
        ).stateCode
      }
    },
    getLoanTypeCode() {
      if (this.loanType !== '') {
        this.loanTypeCode = this.loanTypes.find(
          (x) => x.value === Number(this.loanType)
        ).loanTypeCode
      }
    },

    getMaritalStatusCode() {
      if (this.maritalStatus !== '') {
        this.maritalStatusCode = this.maritalStatusList.find(
          (x) => x.value.toString() === this.maritalStatus.toString()
        ).maritalStatusCode
      }
    },
    getOptionSuffixCode() {
      if (this.suffix !== '') {
        this.suffixCode = this.suffixes.find(
          (x) => x.value.toString() === this.suffix.toString()
        ).suffixCode
      }
    },

    fetchSelectedCRAs() {
      if (this.xpReportSelected !== false) {
        this.getCras.push({
          Id: 2,
          Name: 'EX',
          Report: this.xpReportSelected,
          Score: this.xpScoreSelected,
          Fraud: this.xpFraudSelected,
        })
      }
      if (this.eqReportSelected !== false) {
        this.getCras.push({
          Id: 1,
          Name: 'EQ',
          Report: this.eqReportSelected,
          Score: this.eqScoreSelected,
          Fraud: null,
        })
      }
      if (this.tuReportSelected !== false) {
        this.getCras.push({
          Id: 3,
          Name: 'TU',
          Report: this.tuReportSelected,
          Score: this.tuScoreSelected,
          Fraud: this.tuFraudSelected,
        })
      }
    },

    getFileData() {
      if (this.fileType === 'application/pdf') {
        this.fileType = this.fileType.substring(this.fileType.length - 3)
        this.fileData = this.fileData.replace(
          'data:application/pdf;base64,',
          ''
        )
      }
      if (this.fileType === 'image/tiff') {
        this.fileType = this.fileType.substring(this.fileType.length - 4)
        this.fileData = this.fileData.replace('data:image/tiff;base64,', '')
      }

      if (this.fileType === 'image/tif') {
        this.fileType = this.fileType.substring(this.fileType.length - 4)
        this.fileData = this.fileData.replace('data:image/tif;base64,', '')
      }
    },

    isValiddateBirth() {
      if (this.startdate !== '' || this.coborrowerStartdate !== '') {
        if (
          this.startdate !== '' &&
          new Date().toJSON().slice(0, 10) < this.startdate
        ) {
          this.getModal('Please enter a valid date of birth', 'Alert')
          return false
        }
        if (
          this.coborrowerStartdate !== '' &&
          new Date().toJSON().slice(0, 10) < this.coborrowerStartdate
        ) {
          this.getModal('Please enter a valid date of birth', 'Alert')

          return false
        }
      }
      return true
    },

    searchOrderCCRReports() {
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        this.currentUserId = this.$store.state.auth.currentUser.userInfo.userId
        let parentValidation = response
        that.$validator.validate().then((response) => {
          let childvalidation = response
          if (parentValidation && childvalidation) {
            that.showSpinner = true
            var builtBorrowerObject
            if (
              this.customerId !== '' &&
              this.customerId !== undefined &&
              this.customers.length > 0
            ) {
              this.customerCode = this.customers.find(
                (x) => x.value.toString() === this.customerId.toString()
              ).customerCode
            } else if (this.customers.length === 0) {
              this.customerCode = this.userInfo.customerName
            }

            if (
              this.customerUserId !== '' &&
              this.customerUserId !== undefined &&
              this.customerUserCodeArray.length > 0
            ) {
              this.customerUserCode = this.customerUserCodeArray.find(
                (x) => x.value.toString() === this.customerUserId.toString()
              ).customerUserCode
            } else if (this.customerUserCodeArray.length === 0) {
              this.customerUserCode =
                this.userInfo.firstName + ' ' + this.userInfo.lastName
            }
            if (that.PreviousStreetAddress !== '') {
              builtBorrowerObject = {
                AddressLine1: that.PreviousStreetAddress.replace(/\t/g, ''),
                City: that.PreviousCityName,
                State: Number(that.previousState),
                StateCode: that.previousStateCode,
                Zip: that.previousZip,
                LengthOfStayInYears: that.previousLengthofStayInYears,
                Type: 2,
              }
            }
            var requestString = JSON.stringify({
              Source: 'CPSS UI',
              SourceIp: '',
              Orderid: 0,
              OrderType: 1,
              ForCustomerID: that.customerId,
              ForUserID: that.customerUserId,
              ByCustomerID: that.customerId,
              IsFinancial: that.reportType,
              ByUserID: that.currentUserId,
              ProductId: that.productId,
              UserName: that.customerUserCode,
              CustomerName: that.customerCode, // 'Credit Plus',
              PermissiblePurposeCode: '08',
              CustomerReferenceNumber: that.referenceNumber,
              Borrower: [
                {
                  BorrowerIndex: '1',
                  LastName: that.lastName,
                  MiddleName: that.middleName,
                  Phone: that.phoneNumber.replace(
                    /[`~!@#$%^&*()_|+\-=?;:'",./\s/]/gi,
                    ''
                  ),
                  FirstName: that.firstName,
                  Suffix: Number(that.suffix),
                  suffixCode: that.suffixCode,
                  SSN: that.ssn.replace(
                    /[`~!@#$%^&*()_|+\-=?;:'",./\s/]/gi,
                    ''
                  ),
                  DateofBirth: that.startdate.toString('yyyy-MM-dd'),
                  MaritalStatus: Number(that.maritalStatus),
                  Numberofdependents:
                    that.numberofDependencies !== ''
                      ? that.numberofDependencies
                      : 0,
                  Email: that.email,
                },
              ],
              BorrowerAddresses: [
                {
                  AddressLine1: that.streetAddress.replace(/\t/g, ' '),
                  City: that.cityName,
                  State: Number(that.state),
                  StateCode: that.stateCode,
                  Zip: that.zip,
                  Type: 1,
                  LengthOfStayInYears: that.lengthofStayInYears,
                },
                builtBorrowerObject,
              ],
              Bereaus: [
                {
                  Name: 'EF',
                  report: true,
                  score: true,
                  fraud: false,
                },
                {
                  Name: 'XP',
                  report: false,
                  score: false,
                  fraud: false,
                },
                {
                  Name: 'TU',
                  report: false,
                  score: false,
                  fraud: false,
                },
              ],
            }).replace(/^"(.*)"$/, '$1')
            return this.fetchOrderCCRReport({
              requestString,
            }).then((response) => {
              if (response.request.status !== 200) {
                if (
                  response.response.data.message !== '' &&
                  response.response.data.message !== null &&
                  response.response.data.message !== undefined
                ) {
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: response.response.data.message,
                    variant: constant.errorMessagetype,
                  })
                } else if (
                  response.request.response !== null &&
                  response.request.response !== undefined
                ) {
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: response.request.response,
                    variant: constant.errorMessagetype,
                  })
                }
              } else if (
                response.request.status === 200 &&
                response.data.pdfUrl !== null &&
                response.data.pdfUrl !== '' &&
                response.data.reportByteArray !== undefined &&
                response.data.reportByteArray !== ''
              ) {
                let url = common.downloadFile(
                  response.data.reportByteArray,
                  constant.contentType.pdf,
                  constant.products.EquifaxBPR
                )

                this.$router.open({
                  name: 'pdfviewer',
                  query: {
                    url: url,
                  },
                })
                this.$emit('resetOrderReport')
              } else if (
                response.request.status === 200 &&
                response.data.pdfUrl === null
              ) {
                // this.getModal(
                //   response.data.responseQueueEquifaxModel[0].message,
                //   'Message'
                // )
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: response.data.responseQueueEquifaxModel[0].message,
                  variant: constant.errorMessagetype,
                })
              }
              this.showSpinner = false
            })
          }
        })
      })
    },

    getCustomer() {
      this.customerUser = ''
      this.chooseProduct = ''
      return this.fetchCustomer({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
        .then((response) => {
          let i = 0
          for (i = 0; i < response.data.customers.length; i++) {
            let eachCustomer = response.data.customers[i]
            if (eachCustomer.isActive === true) {
              this.customers.push({
                text: eachCustomer.customerAccNumber + '-' + eachCustomer.name,
                value: eachCustomer.customerId,
                customerCode: eachCustomer.name,
              })
            }
          }
          this.showSpinner = false
        })
        .catch((error) => {
          this.showSpinner = false
          this.authError = error
          this.setAlert({
            title: constant.imageHeaderError,
            msg: constant.errorMessage,
            variant: constant.errorMessagetype,
          })
        })
    },

    toggleEventParent3: function() {
      this.propertyAddressSelected = !this.propertyAddressSelected
      if (this.propertyAddressSelected === true) {
        this.propertyStreetAddress = this.streetAddress
        this.propertyCityName = this.cityName
        this.propertyState = this.state
        this.propertyZip = this.zip
      } else {
        this.propertyStreetAddress = ''
        this.propertyCityName = ''
        this.propertyState = ''
        this.propertyZip = ''
      }
    },
    getConsumerCreditReports(event) {
      this.$validator.validate().then((response) => {
        return response
      })
    },
    onChangeScore(targetval) {
      if (targetval === 'xps') {
        this.xpScoreSelected = event.target.checked

        if (this.xp.indexOf('xpr') === -1) {
          this.xp.push('xpr')
          this.xpReportSelected = event.target.checked
        }
      }

      if (targetval === 'tus') {
        this.tuScoreSelected = event.target.checked

        if (this.tu.indexOf('tur') === -1) {
          this.tu.push('tur')
          this.tuReportSelected = event.target.checked
        }
      }

      if (targetval === 'eqs') {
        this.eqScoreSelected = event.target.checked

        if (this.eq.indexOf('eqr') === -1) {
          this.eq.push('eqr')
          this.eqReportSelected = event.target.checked
        }
      }
      this.showBureauError = false
    },
    onChangeReport(targetval) {
      if (targetval === 'xpr') {
        this.xpReportSelected = event.target.checked

        if (this.xp.indexOf('xps') >= 0) {
          this.xp.splice(this.xp.indexOf('xps'), 1)
        }
      }
      if (targetval === 'tur') {
        this.tuReportSelected = event.target.checked

        if (this.tu.indexOf('tur') >= 0) {
          this.tu.splice(this.tu.indexOf('tur'), 1)
        }
      }

      if (targetval === 'eqr') {
        this.eqReportSelected = event.target.checked

        if (this.eq.indexOf('eqr') >= 0) {
          this.eq.splice(this.eq.indexOf('eqr'), 1)
        }
      }
      this.showBureauError = false
    },
    onChangeFraud(targetval) {
      if (targetval === 'xpf') {
        this.xpFraudSelected = event.target.checked

        if (this.xp.indexOf('xpf') >= 0) {
          this.xp.splice(this.xp.indexOf('xpf'), 1)
        }
        if (this.xp.indexOf('xpr') === -1) {
          this.xp.push('xpr')
          this.xpReportSelected = event.target.checked
        }
      }
      if (targetval === 'tuf') {
        this.tuFraudSelected = event.target.checked

        if (this.tu.indexOf('tuf') >= 0) {
          this.tu.splice(this.tu.indexOf('tuf'), 1)
        }
        if (this.tu.indexOf('tur') === -1) {
          this.tu.push('tur')
          this.tuReportSelected = event.target.checked
        }
      }
      this.showBureauError = false
    },
  },
}
</script>

<template>
  <div>
    <BaseSpinner v-if="showSpinner" />
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <b-form @submit.prevent="orderConsumerCreditReport">
      <b-row class="my-3">
        <b-col md="3">
          <BaseEInputText
            id="referenceNumber"
            v-model="referenceNumber"
            v-validate="{ required: false, regex: /^[A-Za-z0-9 ]+$/ }"
            validattor="^[A-Za-z0-9]+$"
            type="text"
            name="referenceNumber"
            maxlength="15"
            label-content="Reference Number"
            data-vv-as="Reference No."
            :class="{
              input: true,
              'is-danger': errors.has('referenceNumber'),
            }"
            :placeholder="placeholders.referenceNumber"
          />
          <div class="error">
            {{ errors.first('referenceNumber') }}
          </div>
        </b-col>

        <b-col md="6" class="d-none">
          <BaseELabel mark-required label="Report Type" />
          <b-form-group>
            <b-form-radio-group
              :key="typeOption.id"
              v-model="reportType"
              :options="typeOption"
              class="mr-5"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-3" align-v="center">
        <b-col class="border-bottom"></b-col>
      </b-row>
      <b-row class="my-3 border-bottom">
        <b-col md="3">
          <BaseEInputText
            id="firstName"
            v-model="firstName"
            v-validate="{ required: true, regex: /^[A-Za-z0-9-]+$/ }"
            validattor="^[A-Za-z0-9-]+$"
            data-vv-as="First Name"
            type="text"
            name="firstName"
            maxlength="50"
            label-content="First Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('firstName'),
            }"
            :placeholder="placeholders.firstName"
          />
          <div v-show="errors.has('firstName')" class="error">
            First Name is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="middleName"
            v-model="middleName"
            v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
            validattor="^[A-Za-z0-9-]+$"
            data-vv-as="Middle Name"
            type="text"
            name="middleName"
            maxlength="50"
            label-content="Middle Name"
            :class="{
              input: true,
              'is-danger': errors.has('middleName'),
            }"
            :placeholder="placeholders.middleName"
          />
          <div class="error"> {{ errors.first('middleName') }} </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="lastName"
            v-model="lastName"
            v-validate="{
              required: true,
              regex: /^[A-Za-z0-9-]+$/,
            }"
            validattor="^[A-Za-z0-9-]+$"
            data-vv-as="Last Name"
            type="text"
            name="lastName"
            maxlength="50"
            label-content="Last Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('lastName'),
            }"
            :placeholder="placeholders.lastName"
          />
          <div class="error"> {{ errors.first('lastName') }} </div>
        </b-col>
        <b-col md="3">
          <BaseELabel label="Suffix" />
          <BaseDropdown
            v-model="suffix"
            :field-id="suffix"
            :options="suffixes"
            name="sufix"
          />
        </b-col>

        <b-col md="3">
          <BaseEInputText
            id="ssn"
            v-model="ssn"
            v-validate="{ required: true, regex: /^\d{3}-?\d{2}-?\d{4}$/ }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{2})(\d{4})"
            formatter="$1-$2-$3"
            type="text"
            maxlength="11"
            name="ssn"
            label-content="SSN"
            data-vv-as="SSN"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('ssn'),
            }"
            :placeholder="placeholders.ssn"
          />
          <div class="error">
            {{ errors.first('ssn') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel label="Date of Birth" />
          <BaseDate
            v-model="startdate"
            type="date"
            :field-id="startdate"
            name="startdate"
            data-vv-as="Date of Birth"
            :max="maxbirtdate"
            :class="{
              input: true,
              'is-danger': errors.has('startdate'),
            }"
          />
          <div class="error">
            {{ errors.first('startdate') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="phoneNumber"
            v-model="phoneNumber"
            v-validate="{
              required: false,
              regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
            }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{3})(\d{4})"
            formatter="($1) $2-$3"
            type="text"
            maxlength="14"
            name="phoneNumber"
            label-content="Phone Number"
            data-vv-as="Phone #"
            :class="{
              input: true,
              'is-danger': errors.has('phoneNumber'),
            }"
            :placeholder="placeholders.phoneNumber"
          />
          <div class="error">
            {{ errors.first('phoneNumber') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="text-email"
            v-model="email"
            v-validate="'email'"
            maxlength="50"
            type="text"
            name="email"
            label-content="Email ID"
            data-vv-as="Email ID"
            :placeholder="placeholders.email"
          />
          <div class="error">
            {{ errors.first('email') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel label="Marital Status" />
          <BaseDropdown
            id="marital-status"
            v-model="maritalStatus"
            :options="maritalStatusList"
            name="maritalStatus"
          />
        </b-col>
        <b-col md="3">
          <BaseEInputText
            v-model="numberofDependencies"
            v-validate="{ required: false, regex: /^[0-9 ]+$/ }"
            validattor="^[0-9]+$"
            :field-id="numberofDependencies"
            maxlength="2"
            type="text"
            name="numberofDependencies"
            label-content="Number of Dependents"
            :placeholder="placeholders.numberofDependencies"
          />
        </b-col>
      </b-row>

      <b-row class="pb-3 border-bottom">
        <b-col md="5">
          <BaseEInputText
            id="streetAddress"
            v-model="streetAddress"
            v-validate="'required'"
            type="text"
            name="streetAddress"
            maxlength="50"
            label-content="Street"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('street'),
            }"
            :placeholder="placeholders.streetAddress"
          />
          <div v-show="errors.has('streetAddress')" class="error">
            Street is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="cityName"
            v-model="cityName"
            v-validate="{ required: true, regex: /^[A-Za-z -.]+$/ }"
            validattor="^[A-Za-z -.]+$"
            type="text"
            name="cityName"
            maxlength="50"
            label-content="City"
            mark-required
            data-vv-as="City Name"
            :class="{
              input: true,
              'is-danger': errors.has('city'),
            }"
            :placeholder="placeholders.cityName"
          />
          <div class="error">
            {{ errors.first('cityName') }}
          </div>
        </b-col>
        <b-col md="2">
          <BaseELabel mark-required label="State" />
          <BaseDropdown
            v-model="state"
            v-validate="'required'"
            :field-id="state"
            :options="states"
            name="state"
            :placeholder="placeholders.state"
          ></BaseDropdown>
          <div v-show="errors.has('state')" class="error">
            State is required
          </div>
        </b-col>
        <b-col md="2">
          <BaseEInputText
            id="zip"
            v-model="zip"
            v-validate="{ required: true, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
            validattor="[0-9]"
            maskker="(\d{5})(\d{4})"
            formatter="$1-$2"
            type="text"
            maxlength="10"
            name="zip"
            label-content="Zip"
            data-vv-as="Zip"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('zip'),
            }"
            :placeholder="placeholders.zip"
          />
          <div class="error"> {{ errors.first('zip') }} </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="lengthofStayInYears"
            v-model="lengthofStayInYears"
            v-validate="{ required: false, regex: /^[0-9 ]+$/ }"
            validattor="^[0-9]+$"
            maxlength="2"
            type="text"
            label-content="Length of Stay"
            :placeholder="placeholders.lengthofStayInYears"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <BaseELabel label="Previous Address" />
          <BaseSwitch
            id="previousAddress"
            v-model="previousAddress"
            name="previousAddress"
            class="float-left pt-2"
            checkedlbl="Yes"
            uncheckedlbl="No"
            :is-checked="false"
            @toggleEvent="toggleEventParent"
          />
        </b-col>
      </b-row>
      <b-row v-if="previousAddress === true" class="pb-3">
        <b-col md="5">
          <BaseEInputText
            id="PreviousStreetAddress"
            v-model="PreviousStreetAddress"
            v-validate="'required'"
            type="text"
            name="PreviousStreetAddress"
            maxlength="50"
            label-content="Street"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('street'),
            }"
            :placeholder="placeholders.PreviousStreetAddress"
          />
          <div v-show="errors.has('PreviousStreetAddress')" class="error">
            Street is required
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="PreviousCityName"
            v-model="PreviousCityName"
            v-validate="{ required: true, regex: /^[A-Za-z -.]+$/ }"
            validattor="^[A-Za-z -.]+$"
            type="text"
            name="PreviousCityName"
            maxlength="50"
            label-content="City"
            mark-required
            data-vv-as="City Name"
            :class="{
              input: true,
              'is-danger': errors.has('city'),
            }"
            :placeholder="placeholders.cityName"
          />
          <div class="error">
            {{ errors.first('PreviousCityName') }}
          </div>
        </b-col>
        <b-col md="2">
          <BaseELabel mark-required label="State" />
          <BaseDropdown
            v-model="previousState"
            v-validate="'required'"
            :field-id="previousState"
            :options="states"
            name="previousState"
            :placeholder="placeholders.previousState"
          ></BaseDropdown>
          <div v-show="errors.has('previousState')" class="error">
            State is required
          </div>
        </b-col>
        <b-col md="2">
          <BaseEInputText
            id="previousZip"
            v-model="previousZip"
            v-validate="{ required: true, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
            validattor="[0-9]"
            maskker="(\d{5})(\d{4})"
            data-vv-as="Zip"
            formatter="$1-$2"
            type="text"
            maxlength="10"
            name="previousZip"
            label-content="Zip"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('zip'),
            }"
            :placeholder="placeholders.zip"
          />
          <div class="error"> {{ errors.first('previousZip') }} </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="previousLengthofStayInYears"
            v-model="previousLengthofStayInYears"
            v-validate="{ required: false, regex: /^[0-9 ]+$/ }"
            validattor="^[0-9]+$"
            maxlength="2"
            type="text"
            label-content="Length of Stay"
            :placeholder="placeholders.lengthofStayInYears"
          />
        </b-col>
      </b-row>
      <b-row class="border-bottom pt-2"></b-row>
      <b-row class="my-4">
        <b-col md="auto">
          <BaseEButton @click="orderConsumerCreditReport">
            Order
          </BaseEButton>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.input {
  display: block;
  width: 100%;
  margin-bottom: $size-grid-padding;
  background-color: $color-content-bg;
  border: $size-input-border solid $color-input-border;
  border-radius: $size-input-border-radius;
}
</style>
